<template>
  <div class="ddgl">
    <Layout>
      <!-- <ul class="reservationList">
        <li>
          <span>今日核销</span>
          <span>￥{{ zhx.todayVerifyAmount }}</span>
        </li>
        <li>
          <span>本月核销</span>
          <span>￥{{ zhx.monthVerifyAmount }}</span>
        </li>
      </ul> -->
      <Card>
        <p slot="title">订单管理</p>
        <div class="search-area">
          机构：
          <Select v-model="zygValue" class="search-input" clearable placeholder="请选择" size="small">
            <Option v-for="item in zyg" :key="item.value" :label="item.label" :value="item.value"></Option>
          </Select>服务状态：
          <Select v-model="yyztValue" class="search-input" clearable placeholder="请选择" size="small">
            <Option v-for="item in yuyzt" :key="item.value" :label="item.label" :value="item.value"></Option>
          </Select>购买时间：
          <DatePicker v-model="sjValue" align="right" end-placeholder="结束日期" range-separator="至" size="small"
            start-placeholder="开始日期" type="daterange" unlink-panels></DatePicker>
          <Button class="search-button" size="small" type="primary" @click="search()">搜索
          </Button>
          <Button size="small" style="margin-left: 10px" type="primary" @click="verificationClick()">核销
          </Button>
        </div>
        <div class="content">
          <el-table :data="tableData">
            <el-table-column align="center" label="序号" type="index" width="100"></el-table-column>
            <el-table-column align="center" label="订单ID" minWidth="140" prop="id"></el-table-column>
            <el-table-column align="center" label="服务项目" minWidth="120" prop="goodsName"></el-table-column>
            <el-table-column align="center" label="[收货人]" minWidth="80" prop="consignee"></el-table-column>
            <!-- todo -->
            <el-table-column align="center" label="[收货手机号]" minWidth="80" prop="receivingPhone"></el-table-column>
            <el-table-column align="center" label="[收货地址]" minWidth="80" prop="deliveryAddress"></el-table-column>
            <el-table-column align="center" label="物流单号" minWidth="140" prop="logisticsNo"></el-table-column>
            <!--   <el-table-column
              align="center"
              label="[上级机构]"
              minWidth="80"
              prop="userName"
            >
            </el-table-column> -->
            <el-table-column align="center" label="手机" minWidth="150" prop="mobile"></el-table-column>
            <el-table-column align="center" label="实收金额" minWidth="110" prop="totalFee"  :formatter="(row) => (row.totalFee / 100).toFixed(2)"></el-table-column>
            <el-table-column align="center" label="购买日期" minWidth="180" prop="payTime"></el-table-column>
            <el-table-column :formatter="tonum" align="center" label="服务状态" minWidth="110"
              prop="status"></el-table-column>
            <el-table-column align="center" label="核销日期" minWidth="180" prop="verifyTime"></el-table-column>
            <el-table-column align="center" label="【操作】" minWidth="180">
              <template slot-scope="{ row }">

                <span @click="orderGL(row.id, row.status, 7)">发货</span>
                <span @click="orderGL(row.id, row.status, 8)">完结</span>
              </template>
            </el-table-column>
          </el-table>
          <el-pagination :current-page="pagenum" :total="total" background layout="prev, pager, next"
            @current-change="handleCurrentChange"></el-pagination>
        </div>
      </Card>

      <el-dialog :visible.sync="dialogVisible" minWidth="30%" title="核销">
        <p class="mb20">输入用户订单号码进行核销</p>
        <el-input v-model="checkCodeInput" placeholder="请输入"></el-input>
        <span slot="footer" class="dialog-footer">
          <Button @click="dialogVisible = false">取 消</Button>
          <Button class="verify-button" type="primary" @click="verify">去 核 销</Button>
        </span>
      </el-dialog>

      <el-dialog :visible.sync="shipDialogVisible" minWidth="30%" title="发货" @close="resetShipDialog">
        <p class="mb20">请填写物流单号后再确认发货</p>
        <el-input v-model="shipLogisticsNo" maxlength="128" placeholder="请输入物流单号" clearable
          @keyup.enter.native="confirmShip"></el-input>
        <span slot="footer" class="dialog-footer">
          <Button @click="shipDialogVisible = false">取 消</Button>
          <Button class="verify-button" type="primary" @click="confirmShip">确认发货</Button>
        </span>
      </el-dialog>
    </Layout>
  </div>
</template>
<style lang="less" scoped="scoped">
.search-area {
  display: flex;
  justify-content: flex-start;

  .search-date {
    width: 200px;
    margin-right: 20px;
  }

  .search-input {
    width: 150px;
    margin-right: 20px;
  }
}

.button-wrapper {
  margin-bottom: 10px;
}

.search-button {
  margin-left: 10px;
}

.verify-button {
  margin-left: 10px;
}

.reservationList {
  display: flex;

  li {
    width: 628px;
    height: 150px;
    line-height: 150px;
    background: #58b9ca;
    background-size: 100% 100%;
    border-radius: 8px;
    color: #ffffff;
    font-weight: bold;
    margin: 0px 20px 10px 0px;
    text-align: center;

    span {
      padding: 0 15px;
    }
  }
}

.conmain {
  padding: 20px;
  margin: 20px 0;
  background-color: #fff;

  .demo-input-suffix {
    margin: 20px 0;
  }
}
</style>
<script>
import { api } from "@/request/api";
export default {
  data() {
    return {
      total: 10,
      pagenum: 1,
      pagesize: 10,
      zhx: {},
      tableData: [],
      dialogVisible: false,
      shipDialogVisible: false,
      shipOrderId: null,
      shipLogisticsNo: "",
      checkCodeInput: "",
      zyg: [],
      jzzx: [],
      yuyzt: [
        {
          value: "1",
          label: "待支付"
        },
        {
          value: "2",
          label: "已支付"
        },
        {
          value: "3",
          label: "已使用"
        },
        {
          value: "4",
          label: "已退款"
        },
        {
          value: "6",
          label: "待发货"
        },
        {
          value: "7",
          label: "已发货"
        },
        {
          value: "8",
          label: "已完结"
        }

      ],
      zygValue: "",
      yyztValue: "2",
      sjValue: ""
    };
  },
  created() {
    this.zyglist();
    this.ddglzkx();
    this.ddglInquire();
  },
  methods: {
    tonum(row) {
      var num = parseInt(row.status);
      switch (num) {
        case 1:
          return "待支付";
        case 2:
          return "已支付";
        case 3:
          return "已使用";
        case 4:
          return "已退款";
        case 6:
          return "待发货";
        case 7:
          return "已发货";
        case 8:
          return "已完结";
      }
    },
    zyglist() {
      var that = this;
      var parameter = {
        page: 1,
        pagesize: 100
      };
      api.ddglofflineAgencies(parameter).then((response) => {
        response = response.data;
        console.log(response);
        if (response.length > 0) {
          response.forEach((element) => {
            that.zyg.push({
              //中医馆列表
              value: element.id,
              label: element.categoryName
            });
          });
          console.log(that.zyg);
        }
      });
    },
    ddglInquire() {
      //列表
      var that = this;

      var parameter = {
        tcmid: that.zygValue,
        status: that.yyztValue,
        start: Date.parse(that.sjValue[0]),
        end: Date.parse(that.sjValue[1]),

        page: that.pagenum,
        pageSize: that.pagesize
      };


      api.ddglInquire(parameter).then((response) => {
        response = response.data;
        if (response.code == 0) {
          that.total = response.page.totalCount;
          that.tableData = response.page.list;
        }
      });
    },
    ddglzkx() {
      //核销总数
      var that = this;
      api.ddglzkx().then((response) => {
        response = response.data;
        if (response.code == 0) {
          that.zhx = response.data;
        }
      });
    },
    search() {
      //搜索
      this.pagenum = 1;
      this.ddglInquire();
    },
    handleCurrentChange(cpage) {
      //页数
      this.pagenum = cpage;
      this.ddglInquire();
    },
    verificationClick() {
      var that = this;
      that.dialogVisible = true;
    },
    verify() {
      var that = this;
      api
        .ddglOrderCheck({ checkCode: that.checkCodeInput })
        .then((response) => {
          console.log(response);
          response = response.data;
          if (response.code == 0) {
            that.$message({
              type: "success",
              message: "核销成功!"
            });
            that.checkCode = "";
            that.dialogVisible = true;
          } else {
            that.$message({
              type: "success",
              message: response.msg
            });
          }
        });
    },
    refundClick(item) {
      //退款
      var that = this;
      var parameter = item;
      that
        .$confirm("您确定要退款吗?", "提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning"
        })
        .then(() => {
          api.ddglrefundy(parameter).then((response) => {
            console.log(response);
            response = response.data;
            if (response.code == 0) {
              that.$message({
                type: "success",
                message: "退款成功!"
              });
              that.ddglInquire();
            } else {
              that.$message({
                type: "success",
                message: response.msg
              });
            }
          });
          that.ddglInquire();
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消"
          });
        });
    },
    resetShipDialog() {
      this.shipOrderId = null;
      this.shipLogisticsNo = "";
    },
    confirmShip() {
      var that = this;
      var v = (that.shipLogisticsNo || "").trim();
      if (!v) {
        that.$message({
          type: "warning",
          message: "请填写物流单号"
        });
        return;
      }
      var parameter = { id: that.shipOrderId, status: 7, logisticsNo: v };
      api.ddglStatus(parameter).then((response) => {
        response = response.data;
        if (response.code == 0) {
          that.$message({
            type: "success",
            message: "操作成功!"
          });
          that.shipDialogVisible = false;
          that.resetShipDialog();
          that.ddglInquire();
        } else {
          that.$message({
            type: "error",
            message: response.msg || "操作失败"
          });
        }
      });
    },
    orderGL(item, status, n) {
      var that = this;
      var titile = "";

      if (n == 7) {
        if (status >= 7) {
          that.$message({
            type: "info",
            message: "请勿重复发货!!"
          });
          return;
        } else if (status == 1) {
          that.$message({
            type: "info",
            message: "未支付请勿发货!!"
          });
          return;
        }
        that.shipOrderId = item;
        that.shipLogisticsNo = "";
        that.shipDialogVisible = true;
        return;
      } else if (n == 8) {
        if (status >= 8) {
          that.$message({
            type: "info",
            message: "请勿重复完结订单!!"
          });
          return;
        } else
          titile = "您确定要完结订单吗?";
      }

      var parameter = { id: item, status: n };
      that
        .$confirm(titile, "提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning"
        })
        .then(() => {
          api.ddglStatus(parameter).then((response) => {
            console.log(response);
            response = response.data;
            if (response.code == 0) {
              that.$message({
                type: "success",
                message: "操作成功!"
              });
              that.ddglInquire();
            } else {
              that.$message({
                type: "error",
                message: response.msg || "操作失败"
              });
            }
          });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消"
          });
        });
    }
  }
};
</script>
